import CategoryPage from ".";

const ProductCategoryPage = () => (
  <CategoryPage
    type="product"
    title="Data Kategori Produk"
    subtitle="master kategori produk"
    description="Master kategori untuk pengelompokan produk dan transaksi penjualan"
  />
);

export default ProductCategoryPage;
